
<template>
  <CreateOrderTransferPromo office-type="member" use-origin-warehouse :index-route="{ name: 'penjualan.kirim-barang-promo.ke-mitra' }" />
</template>

<script>
import CreateOrderTransferPromo from '../../../../../components/order/create-order-transfer-promo.vue';

export default {
  components: {
    CreateOrderTransferPromo
  }
}
</script>